module.exports = __webpack_public_path__ + "static/img/1-2.1090ab3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/1-2.png
// module id = 59kc
// module chunks = 0